/* eslint-disable eqeqeq */

import {
    Card,
    Row,
    Col,
} from 'react-bootstrap';
import './CompanyInformationTab.scss';
import { useState, useEffect } from 'react';
import CompanyInformationServices from 'services/services/CompanyInformationServices';
import { Spin, Switch, Modal, Form, Input } from 'antd';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import LtvAnalysisServices from 'services/services/LtvAnalysisServices';
import { Button } from 'react-bootstrap';
import { convertToObjectKeyString, TranslateString } from 'Utils/Common';
import { useIntl } from 'react-intl';
import UserService from "services/UserService";
import { useParams } from 'react-router';

const CompanyInformationTab = (props: any) => {
    const [customerDetails, setCustomerDetails] = useState<any>({});
    const [customerLoanData, setCustomerLoanData] = useState<any>([]);
    const [hcinfo, setHcinfo] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);
    const cookies = new Cookies();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ltvDetails, setLtvDetails] = useState<any>({});
    const [isModalOpen, setIsModalOpen] = useState<any>(false);
    const [open, setOpen] = useState<any>(false);
    const intl=useIntl();
    const params = useParams();
    const [currentLoanCreditIdToUpdate, setCurrentLoanCreditIdToUpdate] = useState<any>("");
    const [isNewLoans] = useState<any>(['internal_new','external_new']);


    useEffect(() => {
        getCustomerDetails();
        initialRenderData(); 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    function getCustomerDetails() {
        let object: any = {};
        object.customer_id = props?.id;
        setLoading(true);
        CompanyInformationServices
            .getCustomerData(object)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    setCustomerDetails(response?.data?.customer_data)
                    setCustomerLoanData(response?.data?.loan_data)
                    setHcinfo(response?.data?.hcinfo)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    }

    const initialRenderData = () => {
        let object: any = {};
        object.customer_id = props?.id;

        let ltvAnalysis = cookies.get("ltvAnalysis-"+props?.id);
        if(ltvAnalysis){
            let ltvAnalysis2:any = ltvAnalysis;
            if(typeof ltvAnalysis2 === 'object'){
                object = { ...object, ...ltvAnalysis2}
            }
        }

        setLoading(true)
        LtvAnalysisServices
        .getLtvSummaryData(object)
        .then((response: any) => {
            if (response?.data?.code === 200) {
                const responseData = response?.data?.data;
                setLtvDetails(responseData)
            }
            setLoading(false);
        })
        .catch((err: any) => {
            console.log(err)
            setLoading(false);
        });
    }

    const handleOk = () => {
        setOpen(false);
        setIsModalOpen(!isModalOpen);

    }
    
    const handleCancelPop = () => {
        setOpen(false);
    };

    const updateLoanStatus = async (formData:any) =>{
        setIsModalOpen(!isModalOpen);
        formData.created_by = UserService.getUserFullName();
        formData.customer_id = params?.id;
        formData.loan_id = currentLoanCreditIdToUpdate;
        // formData.status = disabledShareholder ? 'active' : 'inactive';
        // const getAllDataCall = await HousingCompanyService.saveTender(formData)
        // if(getAllDataCall?.data?.code===500){
        //     message.error(intl.formatMessage({id: convertToObjectKeyString(getAllDataCall?.data?.msg)}));
        // }else if(getAllDataCall?.data?.code===200){
        //     message.success(intl.formatMessage({id: convertToObjectKeyString(getAllDataCall?.data?.msg)}));
        //     getAllData();
        // }
    }

    const internalExternalText = (text:any,textType:any) => {
        switch (text) {
            case "Reference interest rate":
                if(isNewLoans.includes(textType)){
                    return TranslateString('Requested reference rate');
                }else{
                    return TranslateString('Reference interest rate');
                }
            case "payment_type":
                if(isNewLoans.includes(textType)){
                    return TranslateString('Requested payment method');
                }else{
                    return TranslateString('payment_type');
                }
            case "yearly_payments":
                if(isNewLoans.includes(textType)){
                    return TranslateString('Requested payment interval');
                }else{
                    return TranslateString('yearly_payments');
                }
            default:
                break;
        }
    }

    return (
        <>
            <Spin spinning={loading} >
                <Row className="my-3 text-left">
                    <Col xs lg="4">
                        <Card className="bg-light" >
                            <Card.Body className="py-1">
                                <div className="h5 ">{TranslateString('Company')}</div>
                                <hr className="my-2 border border-dark" />
                                <table className="table table-sm table-borderless text-dark " width="100%">
                                    <tbody className="cu-text-small">
                                        <tr>
                                            <th className="fw-600">{TranslateString('Address')} :</th>
                                            <td>{customerDetails?.cust_data_address || "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('business_id')} :</th>
                                            <td>{customerDetails?.business_id || "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('Building type')} :</th>
                                            <td>{customerDetails?.cust_data_property_type || "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('Land ownership')} :</th>
                                            <td>{customerDetails?.cust_data_ownership_type || "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('Year of introduction')} :</th>
                                            <td>{customerDetails?.cust_data_buildyear_org || "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('No. of buildings')} :</th>
                                            <td>{customerDetails?.cust_data_num_buildings || "0"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('Apartments')} :</th>
                                            <td>{customerDetails?.cust_data_num_apartments || "0"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('Apartment m2')} :</th>
                                            <td>{customerDetails?.cust_data_apartment_surfacearea || "0"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">&nbsp;&nbsp;&nbsp; {TranslateString('Of which HC owned')} :</th>
                                            <td>{customerDetails?.cust_data_aprt_owned || "0"} {TranslateString('kpl')}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('Commercial apartments')} :</th>
                                            <td>{customerDetails?.commercial_spaces || "0"} </td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('Business space m2')} :</th>
                                            <td>{customerDetails?.cust_data_business_surfacearea || "0"} </td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">&nbsp;&nbsp;&nbsp; {TranslateString('Of which HC owned')} :</th>
                                            <td>{customerDetails?.cust_data_business_owned || "0"} {TranslateString('kpl')}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('number_of_car_spaces')} :</th>
                                            <td>{(customerDetails?.cust_data_num_carspaces && customerDetails?.cust_data_num_carspaces != "NULL")?customerDetails?.cust_data_num_carspaces:"0"} </td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">&nbsp;&nbsp;&nbsp; {TranslateString('Of which HC owned')} :</th>
                                            <td>{customerDetails?.cust_data_carspace_owned_by_hc || "0"} {TranslateString('kpl')}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('Other premises')} : </th>
                                            <td>{customerDetails?.other_spaces || "0"} </td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('Number of floors')} :</th>
                                            <td>{customerDetails?.cust_data_num_floors || "0"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-bold"><u>{TranslateString('housing_manager')}</u></th>
                                            <td>{""}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('name')} :</th>
                                            <td>{hcinfo?.hc_manager_name || "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('phone')} :</th>
                                            <td>{hcinfo?.hc_manager_phone || "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('email')} :</th>
                                            <td>{hcinfo?.hc_manager_email || "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-blod"><u>{TranslateString('housing_company_accountant')}</u></th>
                                            <td>{""}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('name')} :</th>
                                            <td>{hcinfo?.hc_accountants_name || "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('phone')} :</th>
                                            <td>{hcinfo?.hc_accountants_phone || "-"}</td>
                                        </tr>
                                        <tr>
                                            <th className="fw-600">{TranslateString('email')} :</th>
                                            <td>{hcinfo?.hc_accountants_email || "-"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs lg="8">
                        <Card className="bg-light" >
                            <Card.Body className="py-1">
                                <div className="h5 ">{TranslateString('Competitive loan')}</div>
                                <hr className="my-1 border border-dark" />
                                <Row className="mt-4">
                                    {
                                        (() => {
                                            if (customerLoanData?.length > 0) {
                                                return customerLoanData?.map((element: any, index: any) => {
                                                    return (
                                                        <Col key={index} md={6}>
                                                            <table className="table table-sm table-borderless text-dark cu-table-sm border bg-white" width="100%">
                                                                <thead className='border'>
                                                                    <tr className="text-dark fw-bold align-top">
                                                                        <th className="fw-600" colSpan={2}>
                                                                            <div className="d-flex justify-content-between">
                                                                                <div>
                                                                                    {
                                                                                        (()=>{
                                                                                            if(isNewLoans.includes(element?.loan_data_info)){
                                                                                                return <span>{element?.construction_loan?.replace('Uusi laina:',TranslateString('new_loan')) || ""}</span>;
                                                                                            }else{
                                                                                                return <span>{element?.construction_loan || ""}</span>;
                                                                                            }
                                                                                        })()
                                                                                    }
                                                                                </div>
                                                                                <div>

                                                                                    {/* <Switch className='mr-2' title={element?.status ? intl.formatMessage({id:'active_Shareholder'}) : intl.formatMessage({id:'in_active_shareholder'})}
                                                                                     size="small" defaultChecked = {element?.status ? false : true} onChange={() => {
                                                                                            setOpen(true);
                                                                                            setCurrentLoanCreditIdToUpdate(element?.loan_data_credit_id)
                                                                                            }
                                                                                        } /> */}
                                                                                    <span>
                                                                                        <Link to={'/generate-pdf/' + props?.id + '/' + element?.loan_id} target="_blank" className="btn btn-sm cu-btn-green py-0 pull-right">
                                                                                            <span className="cu-m-0 cu-p-0 text-white text-nowrap">
                                                                                                {TranslateString('PDF')}
                                                                                            </span>
                                                                                        </Link>
                                                                                    </span>
                                                                                </div>
                                                                                
                                                                            </div>
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="cu-text-small">
                                                                    <tr>
                                                                        <td></td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-nowrap cu-sentence-case fw-600">{TranslateString('name_of_the_bank')}</th>
                                                                        <td>{element?.name_of_the_bank || "-"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-nowrap cu-sentence-case fw-600">{TranslateString('Lender')}</th>
                                                                        <td>{element?.lender || "-"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-nowrap cu-sentence-case fw-600">{TranslateString('Remaining Capital')}</th>
                                                                        <td>{element?.remaining_capital || "-"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-nowrap cu-sentence-case fw-600">{TranslateString('Remaining loan period')}</th>
                                                                        <td>{element?.remaining_loanperiod?.replace('years', TranslateString('years')) || "-"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-nowrap cu-sentence-case fw-600">{TranslateString('Margin')}</th>
                                                                        <td>{element?.margin || "-"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-nowrap cu-sentence-case fw-600">{internalExternalText('Reference interest rate',element?.loan_data_info)}</th>
                                                                        <td>{element?.reference_interest_rate || "-"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-nowrap cu-sentence-case fw-600">{internalExternalText('payment_type',element?.loan_data_info)}</th>
                                                                        <td>{element?.shortening_period || "-"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-nowrap cu-sentence-case fw-600">{internalExternalText('yearly_payments',element?.loan_data_info)}</th>
                                                                        <td>{element?.yearly_payments || "-"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-nowrap cu-sentence-case fw-600">{TranslateString('interest_rate')}</th>
                                                                        <td>{element?.interest_rate || "-"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-nowrap cu-sentence-case fw-600">{TranslateString('last_reference_data_check')}</th>
                                                                        <td>{element?.last_reference_data_check || "-"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-nowrap cu-sentence-case fw-600">{TranslateString('next_reference_data_check_ci')}</th>
                                                                        <td>{element?.next_reference_data_check || "-"}</td>
                                                                    </tr>
                                                                    {
                                                                        (()=>{
                                                                            if(isNewLoans.includes(element?.loan_data_info)){
                                                                                return (
                                                                                    <>
                                                                                        <tr>
                                                                                            <td className="text-nowrap cu-sentence-case fw-600">{TranslateString('Purpose of the loan')}</td>
                                                                                            <td>{element?.loan_data_purpose || "-"}</td>
                                                                                        </tr>
                                                                                    </>
                                                                                );
                                                                            }
                                                                        })()
                                                                    }
                                                                    <tr>
                                                                        <th>&nbsp;</th>
                                                                        <td>&nbsp;</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </Col>
                                                    );
                                                });
                                            }
                                        })()
                                    }
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Spin>

            <Modal
                open={isModalOpen}
                destroyOnClose
                footer={false}
                onCancel={() => setIsModalOpen(!isModalOpen)}
            >
                <Form
                    requiredMark={false}
                    // name={intl.formatMessage({ id: "Update Shareholder status" })}
                    onFinish={updateLoanStatus}
                    layout="vertical"
                    initialValues={{}}
                >
                    <Form.Item
                        label={<><span>{intl.formatMessage({ id: convertToObjectKeyString("Reason") })}</span><span className="text-danger">*</span></>}
                        name="active_inactive_reason"
                        rules={[{ required: true, message: intl.formatMessage({ id: convertToObjectKeyString('Please input your Reason!') }) }]}
                        className="mb-1"
                    >
                        <Input.TextArea />
                    </Form.Item>
                    <div className="d-flex justify-content-end">
                        <Button type="reset" className="btn btn-sm bg-secondary px-4 border-secondary" onClick={props.handleReset}>{TranslateString('reset')}</Button>
                        &nbsp;
                        <Button type="submit" className="btn btn-sm cu-btn-green px-3">{TranslateString('Submit')}</Button>
                    </div>
                </Form>
            </Modal>

            <Modal
                title=""
                open={open}
                onOk={handleOk}
                okButtonProps={{ className: 'cu-bg-green rounded' }}
                okText={TranslateString('yes')}
                cancelText={TranslateString('no')}
                cancelButtonProps={{ className: 'cu-bg-green rounded' }}
                onCancel={handleCancelPop}
            >
                <p className='h5'>{TranslateString('do_you_want_to_re_activate_the_shareholder_analysis_of_the_housing_company')}</p>
            </Modal>
        </>
    );
};
export default CompanyInformationTab;